/** @jsxImportSource @emotion/react */
import React from "react";
import { css } from "@emotion/react";
import AnalysisIcons from "../../../CommonUi/AnalysisIcons/AnalysisIcons";
import {COMPLIANCE_COLOR_CODES} from "../../../../services/config";

type PositiveViewProps = {
  analysis: any;
  show?:string;
};
type ComplianceCode = "-1" | "0" | "1" | "2" | "3";

const PositiveView: React.FC<PositiveViewProps> = ({
  analysis,
  show,
}) => {
  const responses = analysis?.response || analysis?.responses || [];
  const scrollToResultItem = (item: string) => {
    if (typeof document !== "undefined") {
      const element = document.getElementById(item);
      if (element) {
        const offset = document?.querySelector(".root-layout > div:first-child")?.getBoundingClientRect()?.height || 0;
        const rect = element.getBoundingClientRect();
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        const targetPosition: number = rect.top + scrollTop - (offset + 50);
        window.scrollTo({ top: targetPosition, behavior: "smooth" });
        element.click();
      }
    }
  }; 

  const containerStyle = css`
    display: flex;
    gap: 5px;
    justify-content: start;
    align-items: center;
    flex-wrap: wrap;
  `;  
  return (
    <div css={containerStyle}> 

      {responses.flatMap((resItem: any, index: number) =>     
        
          resItem?.domains.map((dataItem: any)=>{
          let data =`#EAEEF0`;
          if (["-1", "0", "1", "2", "3"].includes(dataItem?.category?.toString())) {
             let key = dataItem.category as ComplianceCode;
             data = COMPLIANCE_COLOR_CODES[key];
            }
            return (
            <AnalysisIcons show={show} scrollTo={scrollToResultItem} imgName={dataItem?.domain_name} colorId={data? data :'#FFC400'} />
            );

        }) || []         
       
      )}
    </div>
  );
};

export default PositiveView;